
import { Component, Vue, Watch } from "vue-property-decorator";
import JobTemplate from "@/modules/JobTemplate/JobTemplate.vue";
import { API_TRoleTemplate } from "@/models/role_templates";
import { API_ROUTES } from "@/utils/API";
import { convertSocItemForDescription, TSocItem_Details } from "@/models/soc_items";
import { API_TCaseCategory } from "@/models/case_profiles";
import { SMQuestionnaire } from "@/store";

@Component({
  components: {
    JobTemplate,
  },
})
export default class VEmployerRole extends Vue {
  get roleTemplateId() {
    return Number(this.$route.params.id || 0);
  }

  loading = false;

  src: API_TCaseCategory[] = [] as API_TCaseCategory[];
  details: TSocItem_Details = ({} as unknown) as TSocItem_Details;
  isEditable = false;

  get attributes() {
    const { src, details, isEditable } = this;

    return {
      src,
      details,
      isEditable,
    };
  }

  get needsUpdate() {
    return SMQuestionnaire.needsUpdate;
  }

  @Watch("needsUpdate", { immediate: true })
  needsUpdateChanged(value: boolean) {
    if (!this.roleTemplateId && !value) return;

    this.fetchRoleTemplateProfile(this.roleTemplateId);

    this.fetchRoleTemplate(this.roleTemplateId);

    SMQuestionnaire.setNeedsUpdate(false);
  }

  async fetchRoleTemplate(id: number) {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TRoleTemplate>(API_ROUTES.ROLE_TEMPLATE(id));

      if (!data) return;

      this.isEditable = data.is_editable;

      await this.fetchJobDescription(data.soc_group_number);
    } finally {
      this.loading = false;
    }
  }

  async fetchJobDescription(soc_code: number) {
    const { data } = await this.axios.get(API_ROUTES.GET_SOC_ITEM(soc_code));

    if (!data) return;

    this.details = convertSocItemForDescription(data);
  }

  async fetchRoleTemplateProfile(id: number) {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TRoleTemplate>(
        API_ROUTES.ROLE_TEMPLATE_PROFILE(id)
      );

      if (!data) return;

      this.src = data.categories;
    } finally {
      this.loading = false;
    }
  }

  @Watch("roleTemplateId", { immediate: true })
  onRoleTemplateId(id: number) {
    if (!id) return;

    this.fetchRoleTemplateProfile(id);

    this.fetchRoleTemplate(id);
  }
}
